import { z } from "zod";

import { DEFAULT_RATE_LIMIT_SETTINGS, RateLimitSettingsSchema } from "../RateLimit.schema";

export const WordDeploymentSettingsSchema = z.object({
  rateLimitSettings: RateLimitSettingsSchema.optional()
});

export type WordDeploymentSettings = z.infer<typeof WordDeploymentSettingsSchema>;

export const DEFAULT_WORD_SETTINGS: WordDeploymentSettings = {
  rateLimitSettings: DEFAULT_RATE_LIMIT_SETTINGS
};

/** Create Word Add-in deployment settings with defaults. Accepts unknown (raw Prisma JsonValue). */
export function createWordDeploymentSettings(overrides?: unknown): WordDeploymentSettings {
  if (!overrides || typeof overrides !== "object" || Array.isArray(overrides)) {
    return { ...DEFAULT_WORD_SETTINGS };
  }
  return { ...DEFAULT_WORD_SETTINGS, ...overrides } as WordDeploymentSettings;
}
